import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

const CheckIcon = ({ className = '', ...rest }) => {
  return <FontAwesomeIcon icon={faCheck} {...rest} className={className} />;
};
export default CheckIcon;
